let activeLog = null

export function setRoomMappingOthersContext(log) {
  activeLog = log ? { ...log } : null
}

export function getRoomMappingOthersContext(ssid, groupId) {
  if (!activeLog) return null
  if (String(activeLog.ssid) !== String(ssid) || String(activeLog.group_id) !== String(groupId)) return null
  return { ...activeLog }
}

